import { DEFAULT_CURRENCY, STAY_OPTIONS } from '@/app/constants'
import { KAYAK_SEARCH_UNSUPPORTED_CURRENCIES } from '@/app/config/kayak-unsupported-currencies'

const KAYAK_UNSUPPORTED_CURRENCIES = new Set<string>(
	KAYAK_SEARCH_UNSUPPORTED_CURRENCIES
)
const KAYAK_STAY_OPTION_IDS = new Set(STAY_OPTIONS.map((option) => option.id))

function coerceQueryString(value: unknown): string | undefined {
	if (typeof value === 'string') return value
	if (value != null && value !== '') return String(value)
	return undefined
}

/** Currency safe for Kayak search-in-place / pick-in-place (known-bad blocklist). */
export function resolveKayakCurrencyCode(raw: string | undefined | null): string {
	const trimmed = coerceQueryString(raw)?.trim() ?? ''
	if (!trimmed || trimmed === 'undefined') return DEFAULT_CURRENCY
	const upper = trimmed.toUpperCase()
	if (!/^[A-Z]{3}$/.test(upper)) return DEFAULT_CURRENCY
	if (KAYAK_UNSUPPORTED_CURRENCIES.has(upper)) return DEFAULT_CURRENCY
	return upper
}

export function resolveKayakCurrencyFromSearchParam(value: unknown): string {
	return resolveKayakCurrencyCode(coerceQueryString(value))
}

/** Kayak `p` / propertyTypes: pipe-separated stay-option ids from STAY_OPTIONS only. */
export function sanitizeKayakStayOptionsParam(
	raw: string | undefined
): string | undefined {
	if (!raw || raw === 'undefined') return undefined
	const ordered: number[] = []
	const seen = new Set<number>()
	for (const piece of raw.split('|')) {
		const trimmed = piece.trim()
		if (!/^\d+$/.test(trimmed)) continue
		const n = parseInt(trimmed, 10)
		if (!KAYAK_STAY_OPTION_IDS.has(n) || seen.has(n)) continue
		seen.add(n)
		ordered.push(n)
	}
	return ordered.length > 0 ? ordered.join('|') : undefined
}
